module.exports = __webpack_public_path__ + "static/media/mapi32_451.332dd364.ico";